// extracted by mini-css-extract-plugin
export default {"card":"Spend_card__DkXXK","month":"Spend_month__n+Vkt","expense":"Spend_expense__YYyed"};